import { queryAgreementByScene, userSignAgreement } from '@/api/basic';

export type AgreementItem = {
  detailUrl: string;
  id: number;
  name: string;
};

const XG_PROMOTION_AGREEMENT: AgreementItem = {
  detailUrl: 'https://cloud-assets-fronts-plus.fengmtech.com/protcol/mini/xglsbgtgxy.html',
  id: -10001,
  name: '《信鸽流水报告推广协议》',
};

const appendXgPromotionAgreement = (list: AgreementItem[]) => {
  if (list.some((item) => item.detailUrl === XG_PROMOTION_AGREEMENT.detailUrl)) return list;
  return [...list, XG_PROMOTION_AGREEMENT];
};

/**
 * platform：平台名称
 * 未登录拉取协议时必传，登录后则可不传
 * 微信小程序：Wechat；移动网页：H5
 *
 * signingScene：场景
 * 微信登录(WECHAT_LOGIN)
 * 微信报告查询首页(WECHAT_REPORT_QUERY_INDEX)
 * H5登录(H5_LOGIN)
 * H5报告查询首页(H5_REPORT_QUERY_INDEX)
 * H5星座查询(H5_XZ)
 * 税票授权协议(SW_REPORT_AUTHORIZED)
 * 云账户提现协议(LHJY_PARTNER_AGREEMENT)
 */
export type AgreeFnParams = {
  platform?: 'Wechat' | 'H5';
  signingScene:
    | 'WECHAT_LOGIN'
    | 'WECHAT_REPORT_QUERY_INDEX'
    | 'H5_LOGIN'
    | 'H5_REPORT_QUERY_INDEX'
    | 'SW_REPORT_AUTHORIZED'
    | 'H5_XZ'
    | 'LHJY_PARTNER_AGREEMENT'
    | 'XG_REPORT_QUERY';
};

export const useAgreement = (params: AgreeFnParams) => {
  if (!params) throw new Error('useAgreement：请传入必要参数');
  const agreements = ref<AgreementItem[]>([]);
  const showAgreement = ref(false);
  const curAgreement = ref<Partial<AgreementItem>>({});

  const showConfirm = ref(false); // 是否展示协议的确认操作栏

  const getAgreements = (param: AgreeFnParams = params) =>
    queryAgreementByScene(param)
      .then((res) => {
        const list = res || [];
        agreements.value =
          param.signingScene === 'XG_REPORT_QUERY' ? appendXgPromotionAgreement(list) : list;
      })
      .catch(
        () =>
          (agreements.value = param.signingScene === 'XG_REPORT_QUERY' ? [XG_PROMOTION_AGREEMENT] : [])
      );

  const viewAgreement = (item: AgreementItem, opt: { withConfirm?: boolean } = {}) => {
    curAgreement.value = item;
    showConfirm.value = !!opt.withConfirm;
    showAgreement.value = true;
  };

  const getSignedIds = () =>
    agreements.value
      .filter((item) => item.id > 0)
      .reduce((pre, cur) => (pre ? `${pre},${cur.id}` : `${cur.id}`), '');

  // 协议埋点
  const saveSignAgreement = ({ signingScene }: { signingScene: number }) => {
    return userSignAgreement({ signingScene, agreementIds: getSignedIds() });
  };

  return {
    agreements,
    showAgreement,
    curAgreement,
    showConfirm,

    getAgreements,
    viewAgreement,
    getSignedIds,
    saveSignAgreement,
  };
};
